import React from 'react';
import {Text} from 'react-native';
import I18n from 'i18n-js';
import styles from '../../../style/adminTools';

export const ListEmpty = ({testID, text}) => (
  <Text style={styles.settingSavingText} testID={testID}>
    {text}
  </Text>
);

export const ListUnavailable = ({testID}) => (
  <Text style={styles.settingErrorText} testID={testID}>
    {I18n.t('customerSettings.listUnavailable')}
  </Text>
);
